/**
 * @generated SignedSource<<f0a9774447d91ac09ce371fad6c17cf8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateServiceGroupInput = {
  name: string;
};
export type ServiceGroupsListAddMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateServiceGroupInput;
};
export type ServiceGroupsListAddMutation$data = {
  readonly createServiceGroup: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"ServiceGroupsListRow_serviceGroup">;
    };
  };
};
export type ServiceGroupsListAddMutation = {
  response: ServiceGroupsListAddMutation$data;
  variables: ServiceGroupsListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceGroupsListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ServiceGroupNode",
        "kind": "LinkedField",
        "name": "createServiceGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceGroup",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ServiceGroupsListRow_serviceGroup"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ServiceGroupsListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ServiceGroupNode",
        "kind": "LinkedField",
        "name": "createServiceGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceGroup",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "ServiceGroupEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a90c9df5522b52ed24137e7a7e2a189",
    "id": null,
    "metadata": {},
    "name": "ServiceGroupsListAddMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceGroupsListAddMutation(\n  $input: CreateServiceGroupInput!\n) {\n  createServiceGroup(input: $input) {\n    node {\n      ...ServiceGroupsListRow_serviceGroup\n      id\n    }\n  }\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment ServiceGroupsListRow_serviceGroup on ServiceGroup {\n  id\n  name\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "b9baa66196338cf4f5539902602650ee";

export default node;
